var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRazer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg145",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 2000 303.9",
    style: {
      enableBackground: "new 0 0 2000 303.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#4B4B4B}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "polygon151",
    className: "st0",
    d: "M1276.3 0v33.4h193.4L1489 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "polygon153",
    className: "st0",
    d: "M1276.3 135.2v33.4h193.4l19.3-33.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "polygon155",
    className: "st0",
    d: "M1276.3 270.4v33.4h193.4l19.3-33.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path157",
    className: "st0",
    d: "M1914.4 94.2V74.9c0-41.4-33.5-74.9-74.9-74.9h-137.9v303.9h33.4V169h62.6l78.1 134.9h38.5L1836.3 169h3.2c41.3.1 74.9-33.4 74.9-74.8zm-179.3-60.8h104.5c22.9.1 41.4 18.6 41.4 41.4v19.3c-.1 22.9-18.6 41.4-41.4 41.4h-104.5V33.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path159",
    className: "st0",
    d: "M212.8 94.2V74.9c0-41.4-33.5-74.9-74.9-74.9H0v303.9h33.4V169h62.9l78.1 134.9H213L134.9 169h3.2c41.3-.1 74.7-33.6 74.7-74.8zM33.4 33.4h104.5c22.9.1 41.4 18.6 41.4 41.4v19.3c-.1 22.9-18.6 41.4-41.4 41.4H33.4V33.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "polygon161",
    className: "st0",
    d: "M531.3 89.2 618 303.8h36L549.3 44.6 531.3 0l-18 44.6-104.8 259.2h36z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path163",
    className: "st0",
    d: "M1941.1 0h21.3v4.2h-8.2v25.2h-4.8V4.2h-8.3V0z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path165",
    className: "st0",
    d: "M1970.6.1h8.2l6.4 23 6.6-23h8.3v29.4h-4.7V5.3h-.5l-6.9 23h-4.9l-7.4-23v24.2h-4.7l-.4-29.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "polygon167",
    className: "st0",
    d: "M850.8 0v33.4H1007l-136.8 237-19.4 33.4h194.7l19.3-33.4H908.7l136.9-237L1064.9 0h-38.6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "polygon169",
    className: "st0",
    d: "M1276.3 0v33.4h193.4L1489 0z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "polygon171",
    className: "st0",
    d: "M1276.3 135.2v33.4h193.4l19.3-33.4z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "polygon173",
    className: "st0",
    d: "M1276.3 270.4v33.4h193.4l19.3-33.4z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "polygon179",
    className: "st0",
    d: "M531.3 89.2 618 303.8h36L549.3 44.6 531.3 0l-18 44.6-104.8 259.2h36z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRazer);
export default __webpack_public_path__ + "static/media/razer.2473409e4902dc8ed32946379efd961b.svg";
export { ForwardRef as ReactComponent };